import PhoneIcon from "@mui/icons-material/Phone";
import { Box, Fab, keyframes, Tooltip } from "@mui/material";
import React from "react";

// Keyframes for the infinite loop animation
const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.15); }
  100% { transform: scale(1); }
`;

const FloatingCallButton = React.memo(() => {
  const phoneNumber = "+998 88 800 28 21";

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: { xs: 24, md: 32 }, // Adjust for mobile and desktop
        right: { xs: 24, md: 32 },
        zIndex: 1000,
      }}
    >
      <Tooltip title="Вызвать Мастера" placement="left">
        <Fab
          href={`tel:${phoneNumber}`} // Replace with your number
          color="primary" // The Fab component uses the theme's primary color
          sx={{
            width: 48,
            height: 48,
            boxShadow: 3,
            animation: `${pulse} 2.5s ease-in-out infinite`, // Infinite pulse animation
          }}
        >
          <PhoneIcon
            sx={{ fontSize: 24, animation: `${pulse} 2.5s ease infinite` }}
          />
        </Fab>
      </Tooltip>
    </Box>
  );
});

export default FloatingCallButton;
